

















import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Tenant } from '@/models/admin/tenant';
import { tenantService } from '@/shared';
import { Base } from '@/components/common/base';
import { RoleType, ValidationRules } from '@/helper/enum';

    @Component({
        props: ['methodName', 'progress'],
        computed: {
            methodtoCall: {
                get() {
                    return this.$props.methodName;
                },
            },
        },
    })
    export default class AddOrUpdateTenantPage extends Base {
        public tenant: Tenant = new Tenant();
        public form: any = {};
        public formFields: Array<VFields<any>> = [];
        public requestProgress: boolean = false;
        public isEnableTenant: boolean =  false;
        public buttons: any = [];
        public created(): void {
            this.setFields();
        }
        public mounted() {
            // activating tab
            this.$root.$emit('sidebar.layout.vue', 'tenant');
            this.buttons = [
            {
                id: '0',
                type: 'button',
                title: 'Back',
                disabled: false,
                visible: true,
                class: 'btn',
                label: 'Back',
                click: 'backToList',
                icon: 'fas fa-arrow-left',
            },
            ];
            this.$emit('updateToolBar', this.buttons);
            this.$watch('methodtoCall', (newVal, oldVal) => {
                if (newVal) {
                    this.callMethod(newVal);
                }
            });
            if (this.$route.params.id) {
                this.getTenant();
            }

            var role = [RoleType.TenantAdmin.toString(), RoleType.SuperAdmin.toString()];
            var isRoleAllowed = this.userSession.roles.filter(x => role.includes(x));
            this.isEnableTenant = isRoleAllowed.includes('T-Admin') || isRoleAllowed.includes('SuperAdmin');
            this.setFields();
        }

        public async callMethod(methodName): Promise<void> {
            if (methodName === 'backToList') {
                this.$router.push({ 
                    name: 'admin.tenants'
                });
            }
            this.resetMethodName(methodName);
        }

        public resetMethodName(methodName): void {
            if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
            }
        }

        public setFields(): void {
            this.formFields = [
                {
                    key: 'name',
                    type: 'v-alynk-text-field',
                    required: true,
                    templateOptions: {
                        counter: 50,
                        label: this.$t('tenants.tenantFields.name') as string,
                        required: true,
                        disabled: false,
                        rules: [
                            v => this.required('Name',v),
                            v => this.alphaSpace(v)
                        ]
                    },
                },
                {
                    key: 'code',
                    type: 'v-alynk-text-field',
                    required: true,
                    templateOptions: {
                        counter: 20,
                        label: this.$t('tenants.tenantFields.code') as string,
                        required: true,
                        disabled: false,
                        rules: [
                            v => this.required('Code',v)
                        ]
                    },
                },
                {
                    key: 'isEnabled',
                    required: false,
                    type: 'v-alynk-switch',
                    templateOptions: {
                        display: this.isEnableTenant,
                        disabled: false,
                        required: false,
                        label: 'Enable Tenant',
                        loading: false,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                    },
                },
            ];
        }

        public tenantValidate(): Vue & { validate: () => boolean } {
            return this.$refs.tenantForm as Vue & { validate: () => boolean };
        }
        
        public async submit(): Promise<void> {
            if (this.tenantValidate().validate()) {
                try {
                    this.requestProgress = true;
                    if (!this.$route.params.id) {
                        await tenantService.addAsync(this.tenant);
                        this.showAlert(true, this.$t('tenants.alertTenantAdded'));
                    } else {
                        await tenantService.updateAsync(this.tenant);
                        this.showAlert(true, this.$t('tenants.alertTenantUpdated'));
                    }
                    this.$router.push({ name: 'admin.tenants' });
                } finally {
                    this.requestProgress = false;
                }
            }
        }

        public async getTenant(): Promise<void> {
            try {
                this.formlyShowSkeleton(this.formFields);
                const response = await tenantService.getAsync(
                    Number(this.$route.params.id),
                );
                this.tenant = response;
            } finally {
                this.formlyHideSkeleton(this.formFields);
            }
        }
    }
